import type { BridgePatientProjection } from '@gh/common/models'
import type { BookingFactRef } from '@gh/common/models'
import { emitClinicalBookingFact } from '@/components/consultation/bookingFacts/emitClinicalBookingFact'

export function buildConsentBookingFactRefs(projection: BridgePatientProjection): BookingFactRef[] {
  const refs: BookingFactRef[] = []
  const consent = projection?.consent
  if (!consent) {
    return refs
  }
  if (consent.consentTreatId) {
    refs.push({ id: consent.consentTreatId })
  }
  if (consent.consentPrivacyId) {
    refs.push({ id: consent.consentPrivacyId })
  }
  if (consent.consentAobId) {
    refs.push({ id: consent.consentAobId })
  }
  return refs
}

export function emitConsentsBookingFactIfReady(projection: BridgePatientProjection | null): void {
  if (!projection) {
    return
  }
  const refs = buildConsentBookingFactRefs(projection)
  if (refs.length === 0) {
    return
  }
  emitClinicalBookingFact({
    factType: 'consents',
    refs,
  })
}
